import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

import auth from './modules/auth';
import chain from './modules/chain';
import notifications from './modules/notifications';
import messages from './modules/messages';
import ingestors from './modules/ingestors';
import metrics from './modules/metrics';
import tables from './modules/tables.js';
import version from './modules/version.js';
import settings from './modules/settings.js';

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    chain,
    notifications,
    messages,
    ingestors,
    metrics,
    tables,
    version,
    settings,
  },
  plugins: [
    createPersistedState({
      key: 'headsup_app_state',
      reducer: (state) => ({
        auth: state.auth,
        messages: state.messages,
        ingestors: state.ingestors,
        version: state.version,
        chains: state.chains
          ? state.chains.map((c) => ({
              id: c.id,
              name: c.name,
              icon: c.icon,
              active: c.active,
              nodes: c.nodes
                ? c.nodes.map((n) => ({
                    id: n.id,
                    name: n.name,
                    network_address: n.network_address,
                    active: n.active,
                  }))
                : [],
            }))
          : [],
        tables: state.tables
          ? {
              types: Object.keys(state.tables.types || {}).reduce(
                (acc, key) => {
                  const { title, colour } = state.tables.types[key];
                  acc[key] = { title, colour };
                  return acc;
                },
                {}
              ),
              tables: state.tables.tables
                ? state.tables.tables.map((table) => ({
                    chain: table.chain,
                    module: table.module,
                    metrics: table.metrics,
                  }))
                : [],
            }
          : {},
      }),
    }),
  ],
});
